function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.59.41A1.405 1.405 0 0012.13.08L.957 4.69A1.396 1.396 0 00.72 7.235l.048.022 4.406 1.825a.499.499 0 00.512-.105L7.993 6.67a.468.468 0 10-.66-.661L5.25 8.097l-4.1-1.689a.438.438 0 01-.22-.437.477.477 0 01.346-.412L12.452.956a.464.464 0 01.477.11c.12.111.167.28.123.437L8.427 12.748a.438.438 0 01-.399.315.438.438 0 01-.437-.218l-1.13-2.726a.473.473 0 00-.874.358l1.142 2.757.022.048c.244.45.718.726 1.23.718h.135a1.37 1.37 0 001.186-.92l4.625-11.24A1.391 1.391 0 0013.59.41z",
  fill: "#54585D",
  fillRule: "nonzero"
})));